export default "__VITE_ASSET__CHP_rZMk__"